import { FileExtensionEnum as e } from "../../../enums/file-extension-enum.mjs";
//#region src/modules/file-uploader/utils/get-mime-type.ts
var t = (t) => {
	let n = t.name.match(/\.[a-zA-Z0-9_-]+$/i);
	switch (n && n[0]) {
		case e.Docx: return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
		case e.Doc: return "application/msword";
		case e.Ttf: return "font/ttf";
		case e.AD_PRT: return "application/vnd.alibre.part";
		case e.AD_SMP: return "application/vnd.alibre.sheet_metal_part";
		case e.AD_ASM: return "application/vnd.alibre.assembly";
		case e.AD_DRW: return "application/vnd.alibre.drawing";
		default: return t.type;
	}
};
//#endregion
export { t as getMimeType };
